import { HeaderSearch } from '@components/SearchV2/ssr/HeaderSearch';
import type { TrendingConfig } from '@components/SearchV2/ssr/HeaderSearch/HeaderSearch.types';
import { denylistFromPayload } from '@components/SearchV2/ssr/HeaderSearch/trendingQueries';
import { resolveTrendingSource } from '@components/SearchV2/ssr/HeaderSearch/trendingSource';
import { useTrendingSearches } from '@components/SearchV2/ssr/hooks/useTrendingSearches';
import { useExposureEvent, useFlags } from '@lib/flags/amplitude/client';
import { Flags } from '@lib/flags/flagConstants';
import { useMemo } from 'react';
import { getLocaleFromUrl } from 'utils';

export const SearchWrapper = ({
  searchPlaceholder,
  searchCompletionHint,
  searchCompletionAccepted,
  searchTopSearchesLabel,
  searchTrendingSearchesLabel,
}: {
  searchPlaceholder: string;
  searchCompletionHint: string;
  searchCompletionAccepted: string;
  searchTopSearchesLabel: string;
  searchTrendingSearchesLabel: string;
}) => {
  const { flags } = useFlags();
  const trendingSource = resolveTrendingSource(flags[Flags.TRENDING_SEARCH]);
  const { payload: trendingPayload, exposureEvent: exposeTrending } =
    useExposureEvent(Flags.TRENDING_SEARCH);
  const { top, trending: rising } = useTrendingSearches(
    trendingSource === 'ua',
    getLocaleFromUrl()
  );
  const trending = useMemo(
    (): TrendingConfig | undefined =>
      trendingSource
        ? {
            source: trendingSource,
            top,
            trending: rising,
            denylist: denylistFromPayload(trendingPayload),
          }
        : undefined,
    [trendingSource, top, rising, trendingPayload]
  );
  // The header owns its own lightweight engine and always full-navigates to
  // /search, where the query is seeded server-side, so it renders the same on
  // every page.
  return (
    <HeaderSearch
      placeholder={searchPlaceholder}
      completionHint={searchCompletionHint}
      completionAcceptedLabel={searchCompletionAccepted}
      topSearchesLabel={searchTopSearchesLabel}
      trendingSearchesLabel={searchTrendingSearchesLabel}
      trending={trending}
      onTrendingSlotShown={exposeTrending}
    />
  );
};
